import { withInstall } from '@ll-plus/utils'

import GroupTitle from './src/group-title.vue'

export const LlGroupTitle = withInstall(GroupTitle)
export default LlGroupTitle
export * from './src/group-title'

declare module 'vue' {
  export interface GlobalComponents {
    LlGroupTitle: typeof GroupTitle
  }
}
